module.exports = __webpack_public_path__ + "img/c.95b83aaa.jpg";